import { render, staticRenderFns } from "@/modules/OCR/templates/ocr-file-list.html?vue&type=template&id=371a4a34&scoped=true&"
import script from "@/modules/OCR/scripts/ocr-file-list.ts?vue&type=script&lang=js&"
export * from "@/modules/OCR/scripts/ocr-file-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/OCR/styles/ocr-file-list.scss?vue&type=style&index=0&id=371a4a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371a4a34",
  null
  
)

export default component.exports